module.exports = __webpack_public_path__ + "static/africa-education-c03bb712480e04823f83847707089fb4.png";